@use "variables" as *;

.container {
  height: 100%;
  width: 100%;
  display: flex;
  align-self: flex-start;
  flex-direction: column;
  overflow: auto;
}

.nameField {
  width: 600px;
  height: 100px;
}

.toolbar {
  min-height: 64px;
  flex-shrink: 0 !important;
}

.searchBar {
  justify-content: center;
}

.toolbarButton {
  height: fit-content !important;
  align-self: center !important;
}

.gridCard {
  display: flex;
  position: relative;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  margin: 0 $spacing-l $spacing-l $spacing-l;
  overflow: auto !important;
  border-radius: 32px !important;
}

.grid {
  width: 100% !important;
  margin: 0 !important;
  padding-right: $spacing-m !important;
  padding-bottom: $spacing-m !important;
}
